import React from 'react';
import { ServiceTemplate } from '../ServiceTemplate';
import { PricingSection } from '../../components/PricingSection';
import { trademarkRegistrationData } from '../../servicesData';

export const TrademarkRegistration = ({ onOpenPopup }) => {
  return (
    <ServiceTemplate
      service={trademarkRegistrationData}
      onOpenPopup={onOpenPopup}
      showPricing={true}
      PricingComponent={PricingSection}
    />
  );
};